import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getSmsTemplates = payload => api.get('/platform/sms-temps', payload)

const getSmsTemplateHtml = payload =>
  api.get(`/platform/sms-temps/${payload.smsTempId}/html-replace-url`, payload)

const getSmsTemplateHisHtml = payload =>
  api.get(`/platform/sms-temps/his/${payload.smsTempId}/html-replace-url`, payload)

const getSmsTemplateLabels = payload => api.get('/platform/sms-temps/labels', payload)

const getSmsTemplateAddableLabels = payload =>
  api.get(`/platform/sms-temps/${payload.smsTempId}/label-addable`, {
    params: payload.params,
  })

const getSmsTemplateById = payload =>
  api.get(`/platform/sms-temps/${payload.smsTempId}`, { params: payload.params })

const getSmsTemplateHisById = payload =>
  api.get(`/platform/sms-temps/his/${payload.smsTempId}`, { params: payload.params })

const createSmsTemplate = payload =>
  api.post(`/platform/sms-temps`, payload.data, { params: payload.params })

const editSmsTemplate = payload =>
  api.put(`/platform/sms-temps`, payload.data, { params: payload.params })

const deleteSmsTemplate = payload =>
  api.delete(`/platform/sms-temps/${payload.smsTempId}`, { params: payload.params })

const deleteSmsTemplateLabel = payload =>
  api.delete(`/platform/sms-temps/labels/${payload.labelId}`, { params: payload.params })

export default {
  getSmsTemplates,
  getSmsTemplateHtml,
  getSmsTemplateHisHtml,
  getSmsTemplateLabels,
  getSmsTemplateAddableLabels,
  getSmsTemplateById,
  getSmsTemplateHisById,
  createSmsTemplate,
  editSmsTemplate,
  deleteSmsTemplate,
  deleteSmsTemplateLabel,
}
